export const downloadResume = (interview) => {
    const candidateName = interview.name;
    const fileName = `${candidateName}.pdf`;
    const a = document.createElement("a");
    a.href = interview.resume;
    a.download = fileName;
    a.click();
}

export const formattedData = (data) => {
    return data.replace(/\b\w/g, (char) => char.toUpperCase());
}

export const getRupeeImage = (level, interview) => {
    let img;
    if (level == 2 && interview.paymentStatus == 1) img = require("@/assets/paneldashboard/YellowRupee.svg");
    else if (level == 2 && interview.paymentStatus == 2) img = require("@/assets/paneldashboard/greenRupee.svg");
    else if (level == 2 && (interview.paymentStatus == 0 || interview.paymentStatus == 3)) img = require("@/assets/paneldashboard/redRupee.svg");
    else img = require("@/assets/paneldashboard/rupee.svg");
    return img;
}

export const openMeetingLink = (link) => {
    window.open(link);
}

export const isWithinTwoHours = (timeString) => {
    let [datePart, timePart] = timeString.split(", ");
    let [day, month, year] = datePart.split(".").map(Number);
    let [startTime, endTime] = timePart.split(" - ").map(str => str.trim());

    // Extract AM/PM
    let periodStart = startTime.includes("PM") ? "PM" : "AM";
    let periodEnd = endTime.includes("PM") ? "PM" : "AM";

    // Remove AM/PM properly and split by ":"
    let [startHour, startMinute] = startTime.replace(/AM|PM/, "").trim().split(":").map(Number);
    let [endHour, endMinute] = endTime.replace(/AM|PM/, "").trim().split(":").map(Number);

    // Convert to 24-hour format
    if (periodStart === "PM" && startHour !== 12) startHour += 12;
    if (periodStart === "AM" && startHour === 12) startHour = 0;
    if (periodEnd === "PM" && endHour !== 12) endHour += 12;
    if (periodEnd === "AM" && endHour === 12) endHour = 0;

    // Create Date objects
    let startDate = new Date(year, month - 1, day, startHour, startMinute, 0);

    // Create Date object for start time
    let startTimestamp = Math.floor(startDate.getTime() / 1000); // Convert to Unix timestamp (seconds)

    // Get current timestamp
    let nowTimestamp = Math.floor(Date.now() / 1000);
    // Calculate difference in seconds
    let diffSeconds = startTimestamp - nowTimestamp;
    // Check if within 2 hours (7200 seconds)
    if (diffSeconds > 0 && diffSeconds <= 7200) { // Within 2 hours

        let remainingMinutes = Math.ceil(diffSeconds / 60);
        let roundedMinutes = remainingMinutes < 15
            ? remainingMinutes // Show exact minutes if less than 15
            : Math.round(remainingMinutes / 15) * 15; // Round to 15-min intervals

        let hours = Math.floor(roundedMinutes / 60);
        let minutes = roundedMinutes % 60;

        let result = "";
        if (hours > 0) result += `${hours} hour`;
        if (minutes > 0) result += ` ${minutes} minutes`;
        if (hours <= 0 && minutes == 1) result = ` ${minutes} minute`;
        else if (hours == 2 && minutes <= 0) result = `${hours} hours`;
        if (result) return `Interview in ${result.trim()}`;
        else return false;
    }
    else if (checkOngoing(timeString)) {
        return 'ongoing';
    }

    return false;
}


export const checkOngoing = (timeString) => {
    let [datePart, timePart] = timeString.split(", ");
    let [day, month, year] = datePart.split(".").map(Number);
    let [startTime, endTime] = timePart.split(" - ").map(str => str.trim());

    // Extract AM/PM
    let periodStart = startTime.includes("PM") ? "PM" : "AM";
    let periodEnd = endTime.includes("PM") ? "PM" : "AM";

    // Remove AM/PM properly and split by ":"
    let [startHour, startMinute] = startTime.replace(/AM|PM/, "").trim().split(":").map(Number);
    let [endHour, endMinute] = endTime.replace(/AM|PM/, "").trim().split(":").map(Number);

    // Convert to 24-hour format
    if (periodStart === "PM" && startHour !== 12) startHour += 12;
    if (periodStart === "AM" && startHour === 12) startHour = 0;
    if (periodEnd === "PM" && endHour !== 12) endHour += 12;
    if (periodEnd === "AM" && endHour === 12) endHour = 0;

    // Create Date objects
    let startDate = new Date(year, month - 1, day, startHour, startMinute, 0);
    let endDate = new Date(year, month - 1, day, endHour, endMinute, 0);

    // Ensure valid date parsing
    if (isNaN(startDate) || isNaN(endDate)) {
        console.error("Invalid Date detected. Check input format:", timeString);
        return false;
    }

    let nowTimestamp = Math.floor(Date.now() / 1000);
    let startTimestamp = Math.floor(startDate.getTime() / 1000);
    let endTimestamp = Math.floor(endDate.getTime() / 1000);

    return nowTimestamp >= startTimestamp && nowTimestamp < endTimestamp;
};


export const getFormattedTime = (interview) => {
    let time = interview.slotStartTime + ` -${interview.slot.split('-')[1]}`;
    return time.replace(/\./g, "-");
}

export const getAmountToolTip = (level, status) => {
    if (level == 2) {
        let text = status == 1 ? 'Payment Pending' : status == 2 ? 'Payment Done' : status == 3 || status == 0 ? 'Payment Rejected' : null;
        return text;
    }
    return null;
}

export const formattedArray = (data) => {
    return data.map(element => element.replace(/\b\w/g, (char) => char.toUpperCase()))
}

export const getUserIcon = (name) => {
    const words = name.trim().split(/\s+/);
    return words.length === 2
        ? (words[0][0] + words[1][0]).toUpperCase()
        : name.substring(0, 2).toUpperCase();
}

export const formattedDate = (date) => {
    if (!date) return "-";
    let formattedDate = date
        .slice(0, 10)
        .split("-")
        .reverse()
        .join("-");
    return formattedDate.replaceAll("/", "-");
}

export const is15MinutesOrLess = (str) => {
    const [dateStr, timeStr] = str.split(",");

    // Parse date
    const [day, month, year] = dateStr.trim().split(".").map(Number);

    // Parse time "09:00 PM"
    let [time, modifier] = timeStr.trim().split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    // Convert 12h -> 24h
    if (modifier === "PM" && hours !== 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;

    // Build the Date object for the event
    const startDateTime = new Date(year, month - 1, day, hours, minutes, 0, 0);

    const now = new Date();

    // Difference in minutes
    const diffMinutes = (startDateTime - now) / (1000 * 60);

    return diffMinutes <= 15 && diffMinutes >= 0;
}

export const showReschedule = (interview, id) => {
    if (!is15MinutesOrLess(interview.slotStartTime)) {
        if (!interview.interviewInfo.reschedule && !interview?.interviewInfo?.rescheduleHistory) return true;
        else {
            let allUserIds = interview.interviewInfo.rescheduleHistory.map(obj => { return obj.requesterUserID })
            if (interview.interviewInfo.reschedule.requesterUserID == id || allUserIds.includes(id)) {
                return false;
            }
            return true;
        }
    }
    return null;
    // return !is15MinutesOrLess(interview.slotStartTime) &&  (!interview.interviewInfo.reschedule && !interview?.interviewInfo?.rescheduleHistory)
}

export const showRescheduleText = (interview, id) => {
    if (!interview.interviewInfo.reschedule && !interview?.interviewInfo?.rescheduleHistory) return false;
    else if (interview.interviewInfo.reschedule.requesterUserID == id) return true;
    return false;
}

export const showRescheduled = (interview, id) => {
    if (interview.interviewInfo?.rescheduleHistory && interview.interviewInfo?.rescheduleHistory.length != 0) {
        let userData = interview.interviewInfo.rescheduleHistory.slice().reverse().find(obj => obj.requesterUserID == id)
        if (userData && Object.keys(userData).length != 0 && userData.status == 'accepted') {
            return true;
        }
        return false;
    }
    return false;
}